import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-group-confirm-conversion-admin-dialog',
  templateUrl: './group-confirm-conversion-admin-dialog.component.html',
  styleUrls: [
    '../group-confirm-leave-dialog/group-confirm-leave-dialog.component.scss',
  ],
})
export class GroupConfirmConversionAdminDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<GroupConfirmConversionAdminDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    console.log(this.data);
  }

  onYesClick() {
    let data = {
      status: 'yes',
    };
    this.dialogRef.close(data);
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
